import { pixelMask, TILE_SYMBOLS } from '@/utils/tilePixels';
import { colors } from '@/styles';
import { Signal } from '@/models/data/Signal';
import { TileType } from '@/models/TileTypes';
import { TileDefinition, TileGraphicsDefinition } from '@/models/tiles/TileDefinition';
import { Side, TileSideIOType } from '@/schemas/tiles';

import {
  defaultTileGraphics,
  sideGraphics,
  connectionGraphics,
} from '@/models/tiles/DefaultTileGraphics';
import { standardBuildAndConnect } from '@/models/logic/utils';

export const randomIoSides = {
  [Side.TOP]: { type: TileSideIOType.NONE, forceConnection: false },
  [Side.RIGHT]: { type: TileSideIOType.OUTPUT, forceConnection: true },
  [Side.BOTTOM]: { type: TileSideIOType.NONE, forceConnection: false },
  [Side.LEFT]: { type: TileSideIOType.INPUT, forceConnection: true },
};

export interface RandomTileState {
  prevInput: Signal | null;
  lastOutput: Signal;
}

export class RandomTile implements TileDefinition<RandomTileState> {
  graphics = randomTileGraphicsDefinition;
  type = TileType.Random;

  name = 'Random';
  canRotate = true;

  createDefaultState = () => ({
    prevInput: null,
    lastOutput: Math.random() > 0.5 ? Signal.HIGH : Signal.LOW,
  });

  buildAndConnectNodes = (data: any) => standardBuildAndConnect('RANDOM', data, this);

  ioSides = randomIoSides;
}

export const randomTileGraphicsDefinition: TileGraphicsDefinition<RandomTileState> = {
  type: TileType.Random,
  draw: function (g, { meta, connections, context }): void {
    defaultTileGraphics(g);
    sideGraphics(g, randomIoSides, colors.signalColor, colors.noSignalColor, meta);
    connectionGraphics(
      g,
      colors.signalColor,
      colors.noSignalColor,
      meta,
      connections,
      randomIoSides,
      context,
    );

    const color =
      meta.outputs.right === Signal.HIGH ? colors.signalColor : colors.noSignalColor;

    pixelMask(g, TILE_SYMBOLS.random, 4, 4, color);
  },
};
